class WishlistRemoveItem extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.removeItem = this.removeItem.bind(this)
    this.removeItemOnKey = this.removeItemOnKey.bind(this)
    this.listeners.add(this, 'click', this.removeItem)
    this.listeners.add(this, 'keydown', this.removeItemOnKey)
  }

  // #386: the host is role="button", so it has to answer Enter and Space the
  // way a native button does. removeItem's preventDefault also stops Space
  // from scrolling the page.
  removeItemOnKey (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return

    this.removeItem(e)
  }

  async removeItem (e) {
    e.preventDefault()

    window.BAO.wishlist.genericModalHeading = this.modalHeading
    window.BAO.wishlist.genericModalText = this.modalText
    window.BAO.wishlist.genericModalCancelText = this.modalCancelText
    window.BAO.wishlist.genericModalContinueText = this.modalContinueText
    window.BAO.wishlist.openGenericModal()

    window.BAO.wishlist.genericModalContinue = async () => {
      await window.BAO.wishlist.removeItem(this.listId, this.itemId, this.token)

      window.location.reload()
    }
  }

  get listId () {
    return this.dataset.listId
  }

  get itemId () {
    return this.dataset.itemId
  }

  get token () {
    return window.BAO.wishlist.token
  }

  get modalHeading () {
    return this.dataset.modalHeading
  }

  get modalText () {
    return this.dataset.modalText
  }

  get modalCancelText () {
    return this.dataset.modalCancelText
  }

  get modalContinueText () {
    return this.dataset.modalContinueText
  }
}

customElements.define('wishlist-remove-item', WishlistRemoveItem)
